import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import StarRating from "../common/StarRating";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

const ProductDetailsPopup = ({ product, onClose, language }) => {
  const { t } = useTranslation("home");
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  console.log(product)

  // Get image base path from environment or config
  const imgSrc = process.env.REACT_APP_IMAGE_BASE_URL || "";

  const styles = {
    scrollToTop: {
      position: "fixed",
      bottom: "50px",
      right: "50px",
      padding: "10px 20px",
      fontSize: "18px",
      borderRadius: "5px",
      backgroundColor: "transparent",
      color: "#fff",
      border: "none",
      cursor: "pointer",
      zIndex: 1000,
      transition: "opacity 0.3s ease-in-out",
    },
  };

  if (!product) return null;

  return (
    <div className='product-details-popup' role='dialog' aria-modal='true'>
      <div className='popup-overlay' onClick={onClose} aria-hidden='true'></div>
      <div className='popup-content'>
        <button className='close-btn' onClick={onClose} aria-label={t("close")}>
          ×
        </button>
        <div className='row'>
          <div className='col-md-6'>
            <div className='product-image-container'>
              {product?.images?.length > 0 ? (
                <>
                  <Swiper
                    style={{
                      "--swiper-navigation-color": "#fff",
                      "--swiper-pagination-color": "#fff",
                    }}
                    spaceBetween={0}
                    navigation={true}
                    thumbs={{
                      swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
                    }}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className='mySwiper2'>
                    {product.images.map((image, index) => (
                      <SwiperSlide key={`main-${index}`}>
                        <img
                          src={`${image.image_path}`}
                          alt={`${language === "ar" ? product.name_ar : product.name_en} - ${index + 1}`}
                          loading='lazy'
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>

                  <Swiper
                    onSwiper={setThumbsSwiper}
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className='mySwiper'>
                    {product.images.map((image, index) => (
                      <SwiperSlide key={`thumb-${index}`}>
                        <img src={`${image.image_path}`} alt={`Thumbnail ${index + 1}`} loading='lazy' />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </>
              ) : (
                <div className='no-images-available'>{t("no_images_available")}</div>
              )}
            </div>
          </div>
          <div className='col-md-6'>
            <h2>{language === "ar" ? product.name_ar : product.name_en}</h2>
            <div className='in_stock'>
              <div></div> <span>{t("in_stock")}</span>
            </div>
            {/* <div className="description">
              {language === "ar" ? product.description_ar : product.description_en}
            </div> */}
            <div
              className='description'
              dangerouslySetInnerHTML={{
                __html:
                  language === "ar"
                    ? product.description_ar?.replace(/\n/g, "<br />") ?? "وصف المنتج"
                    : product.description_en?.replace(/\n/g, "<br />") ?? "product description",
              }}
            />
            <div className='star'>
              <StarRating rating={product.rating || 3} />
            </div>
            <div className='details'>
              <div>
                {t("code")} : {product.code}
              </div>
              <div>
                {/* {t("category")} :{language === "ar" ? product.category.name_ar : product.category.name_en} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsPopup;
